var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "sos-popup-overlay",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.close.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "sos-popup" }, [
            _c("div", { staticClass: "sos-popup__header" }, [
              _c("h3", { staticClass: "sos-popup__title" }, [
                _vm._v("\n        Search stats\n      "),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "sos-popup__close",
                  attrs: { type: "button" },
                  on: { click: _vm.close },
                },
                [_vm._v("\n        ×\n      ")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sos-popup__body" },
              [
                _vm.loading
                  ? _c("div", { staticClass: "sos-popup__loader" }, [
                      _c("div", { staticClass: "sos-spinner" }),
                    ])
                  : [
                      _vm.error
                        ? _c("div", { staticClass: "sos-popup__error" }, [
                            _vm._v(
                              "\n          " + _vm._s(_vm.error) + "\n        "
                            ),
                          ])
                        : _c("div", { staticClass: "sos-popup__content" }, [
                            _c("div", { staticClass: "sos-popup__chart" }, [
                              _c("canvas", { ref: "chartCanvas" }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "sos-popup__titles" }, [
                              _c(
                                "div",
                                { staticClass: "sos-popup__titles-header" },
                                [
                                  _c("h4", [
                                    _vm._v(
                                      "Titles (" +
                                        _vm._s(_vm.titles.length) +
                                        ")"
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "sos-popup__titles-list" },
                                [
                                  _c(
                                    "ul",
                                    _vm._l(_vm.titles, function (title, index) {
                                      return _c("li", {
                                        key: index,
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.highlight(title)
                                          ),
                                        },
                                      })
                                    }),
                                    0
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                    ],
              ],
              2
            ),
          ]),
        ]
      )
    : _c("div")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }